import { useState } from 'react';
import { datosArchivos, guardarArchivos, listarArchivoDetalleById, listarArchivosMinvu } from '../services/segurosServices';
import { descargarExcelCobroSeguro, descargarTxtCobroSeguro } from '../../../detalleMutuo/services/servicesReportes';
import { Archivominvu, ArchivoMinvuDTO, DatosArchivoDTO, GuardarArchivoDTO } from '../models/cobroSeguros';
import { SeguroMinvu, StatusCode } from '../../../../utils/enums';
import { useToast } from '../../../../hooks/useToast';
import { AxiosResponse } from 'axios';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';

const useArchivoMinvu = () => {
    const { addToast } = useToast();
    const [dataListSeguro, setDataListSeguro] = useState<Archivominvu[]>([]);
    const [dataListArchivo, setDataListArchivo] = useState<ArchivoMinvuDTO[]>([]);
    const getDataListSeguro = async () => {
        const resp: AxiosResponse<ListResponseDto<Archivominvu>> = await listarArchivosMinvu();
        if (resp.status !== StatusCode.Ok) {
            return;
        }
        setDataListSeguro(resp.data.items);
    };

    const getDataListArchivo = async (id: number) => {
        const resp: AxiosResponse<ListResponseDto<ArchivoMinvuDTO>> = await listarArchivoDetalleById(id);
        if (resp.status !== StatusCode.Ok) {
            return;
        }
        setDataListArchivo(resp.data.items);
    };

    const descargarArchivo = async (listaArchivo: ArchivoMinvuDTO[], render: () => void) => {
        if (listaArchivo.some(x => x.archivominvuId === null || x.archivominvuId === undefined || x.archivominvuId !== 0 || x.estado === SeguroMinvu.ESTADOSEGUROMINVU_COBRADO)) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'Debe seleccionar un archivo que no haya sido cobrado.'
            });
            return;
        }

        const tipoSubsidio = listaArchivo[0].codigoTipoSubsidio;
        const datos = await datosArchivos(tipoSubsidio);
        if (datos.status !== StatusCode.Ok)
            return;

        const data: DatosArchivoDTO = await datos.data;

        let respExcel: AxiosResponse | undefined;
        let respTxt: AxiosResponse | undefined;

        try {
            [respExcel, respTxt] = await Promise.all([
                descargarExcelCobroSeguro(listaArchivo, data.nombreArchivo),
                descargarTxtCobroSeguro(listaArchivo, data.nombreArchivo)
            ]);
        } catch {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'Ocurrió un error al descargar los archivos de cobro.'
            });
            return;
        }

        if (!respExcel || !respTxt || respExcel.status !== StatusCode.Ok || respTxt.status !== StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'No se pudieron descargar correctamente los archivos de cobro.'
            });
            return;
        }

        const request: GuardarArchivoDTO = {
            listaArchivos: listaArchivo,
            datosArchivo: data
        };

        const resp = await guardarArchivos(request);
        if (resp.status !== StatusCode.NoContent) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'No se pudo guardar el archivo descargado.'
            });
        } else {
            addToast({
                mostrar: true,
                titulo: 'Éxito',
                tipo: 'Success',
                mensaje: 'El archivo se guardó correctamente.'
            });
        }

    };

    return {
        descargarArchivo,
        getDataListSeguro,
        getDataListArchivo,
        dataListArchivo,
        dataListSeguro
    };
};

export default useArchivoMinvu;